import { render, staticRenderFns } from "./EditAttributeDialog.vue?vue&type=template&id=53ab0f8c&scoped=true"
import script from "./EditAttributeDialog.vue?vue&type=script&lang=js"
export * from "./EditAttributeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ab0f8c",
  null
  
)

export default component.exports